import { render, staticRenderFns } from "./escribirRegistro.vue?vue&type=template&id=27324158"
import script from "./escribirRegistro.vue?vue&type=script&lang=js"
export * from "./escribirRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports